import { Component, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import saveAs from 'file-saver';
import { acdSummary, AttachmentDetails, AcdFormAttachmentList, CommentDataModel, EditCommentModel, CloseCancelDataModel } from 'src/app/interfaces/dashboard';
import { FileNameTransformPipe } from 'src/app/pipes/filename-transform.pipe';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { AttachmentService } from 'src/app/services/attachment.service';
import { commonService } from 'src/app/services/common.service';
import { AcdService } from 'src/app/services/dashboard.service';
import { mwoService } from 'src/app/services/mwo.service';
import { getAcdEnvConfig } from 'src/app/configs/acd-env.config';
import { EMDMICONS } from 'src/app/features/common/constants/icon-pack.constant';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-acd-request-view',
  templateUrl: './acd-request-view.component.html',
  styleUrl: './acd-request-view.component.scss'
})
export class AcdRequestViewComponent {
  public crNo!: number;
  public cr: object | undefined;
  statusFlag: string = '';
  acdviewrequestTable: any = [];
  Description = '';
  Justification = '';
  public acdsummarydata: Array<acdSummary> = [];
  public commentsHistory: any;
  closeIcon = this.iconPack.Faclose;
  downloadIcon = this.iconPack.faDownload;
  isPopupLoading: boolean = false;
  isLoading: boolean = false;
  isReloading: boolean = false;
  showpopup: boolean = false;
  showeditpopup: boolean = false;
  showclosepopup: boolean = false;
  showcancelpopup: boolean = false;
  editCommentOpenedId: number = 0;
  newPrioirtyList = new Array<string>;
  newStatusList = new Array<string>;
  specialist: boolean = false;
  ownRequest: boolean = true;
  otherUser: boolean = false;
  userInfo: any;
  anchorElement: any;
  buildStatus: boolean = false;
  selectedStatus: number = 0;
  priorityList: any = [];
  selectedPriorityItem: string = "";
  statusList: any = [];
  newCommentValue: string = '';
  uploadFileUrl: string = '';
  removeFileUrl: string = '';
  uploadedFile: string = '';
  getComment: any = [];
  currentFileUpload: any = [];
  fileAttachmentDetails = new Array<AttachmentDetails>();
  deletedFileList = new Array<AttachmentDetails>();
  crAttachmentDetails = new Array<AttachmentDetails>();
  filePipe = new FileNameTransformPipe();
  acceptedFileTypes: string[] = this.commonservice.commonAcceptedFiles;
  fileName: string = '';
  popuperror: boolean = false;
  acdFileAttachmentList = new Array<AcdFormAttachmentList>();
  prioritySelected = this.statusList[4];
  popupShow = false;
  popupTitle = "";
  popupHeight = 400;
  popupWidth = 800;
  isUserCanAccessRequest = true;  
  acdEnv = getAcdEnvConfig(); 
  summaryType = this.acdEnv.summaryType; 
  hiddenColumns: any = ['submitDate', 'dueDate']
  @HostListener('document:keydown.escape', ['$event1']) handleEscapeEvent(event: KeyboardEvent) {
    this.closePopup();
  }

  // @HostListener('document:click',['$event']) onDocumentClick(event:MouseEvent){
  //   const target = event.target as HTMLElement;

  //   const clickedInsidePopup = target.closest('.popupDialog');

  //   if(!clickedInsidePopup){
  //     this.closePopup();
  //   }
  // }

  iconPacks = EMDMICONS;

  constructor(
    private acdservice: AcdService,
    private route: ActivatedRoute,
    private iconPack: EmdmIcons,
    private commonservice: commonService,
    private attachmentservice: AttachmentService,
    private mwoservice: mwoService,
    private router: Router
  ) {
    this.acdsummarydata = [];
    this.commentsHistory = [];
  }

  ngOnDestroy() {
    this.commonservice.setPageTitle(`EMDM CMMS`);
  }
  ngOnInit() {
    // this.isLoading = true;
    this.commonservice.isSpecialist.subscribe((x: boolean) => {
      this.specialist = x;
    })
    //admin role
    this.commonservice.isAdmin.subscribe((x: boolean) => {
      this.specialist = x|| this.specialist;
    })

    this.route.queryParams.subscribe((param: any) => {
      //TODO - Reset properties for load new CR
      if (param['CR']) {
        this.crNo = param['CR'];

        //Api for view request
        if (this.crNo > 0) {
          this.getAllChangeRequestData(this.crNo);
          this.commonservice.setPageTitle(`EMDM CMMS - CR#${this.crNo}`)
        }
        this.crAttachmentDetails = [];
      }
    });
  }
  hideSubmitDate: boolean = true;
  getAllChangeRequestData(crNo: number) {
    this.isLoading = true;
    this.acdservice.getWholeChangeRequest(crNo).subscribe((data) => {
      if (data) {
        this.acdsummarydata = data.acdSummaries;
        this.commentsHistory = data.commentHistories;
        this.setCommentHistory();
        this.priorityList = data.requestPriorities;
        this.statusList = data.changeRequestStatusResponse;
        this.acdviewrequestTable[0] = data;
        this.acdviewrequestTable[0].id = 'CR' + data.id;
        this.acdviewrequestTable[0].onBehalfOfId = data.onBehalfOf.id;
        this.acdviewrequestTable[0].onBehalfOf = data.onBehalfOf.name;
        this.acdviewrequestTable[0].requestor = data.createdBy.name;
        this.acdviewrequestTable[0].status = data.changeRequestStatus.label;
        this.acdviewrequestTable[0].assignedTo = data.assignedTo?.name ?? null;
        this.acdviewrequestTable[0].facility = data.facility.label;
        this.acdviewrequestTable[0].priority = data.requestPriority.label;
        if(this.acdviewrequestTable[0].submissionDateTime){
          this.hideSubmitDate = false;
        }
        this.acdviewrequestTable[0].submitDate = data.submissionDateTime || "";
        this.acdviewrequestTable[0].dueDate = data.dueDateTime || "";
        this.Description = data.description;
        this.Justification = data.justification;
        let priorityData = this.priorityList?.filter((x: any) => x.label == data.requestPriority.label)[0];
        this.selectedPriorityItem = priorityData ? data.requestPriority.label + ' (' + priorityData.numberofdays + ')' : data.requestPriority.label;
        this.isUserCanAccessRequest = data.isUserCanAccessRequest;
        this.statusFlag = data.changeRequestStatus.label.toLowerCase();

        this.crAttachmentDetails = data.changeRequestAttachments.map((item: any) => ({
          ...item,
          blobURI: item.blobUri
        }));

        this.setOwnRequest();
        if (["new", "completed", "submitted"].includes(data.status.toLowerCase())) {
          this.hiddenColumns = []
        }

        if (this.statusFlag == "build") {
          this.buildStatus = true;
        }
        if (this.isStatusBuild()) {
          this.priorityList.map((newData: any) => {
            this.newPrioirtyList.push(newData.label +  ' (' + newData.numberofdays +')');
          })

          this.statusList.map((newData: any) => {
            this.newStatusList.push(newData.status);
          })
        }
      }

    }, (error) => {
      this.router.navigateByUrl(`internal-error`);
    })
  }

  setCommentHistory(){
    this.commentsHistory.forEach((element: any) => {
      if (element?.filenametext != null) {
        const fileNames = element.filenametext.split(',');
        const blobUris = element.blobURIText.split(',');
        const attachmentIds = element.attachmentId.split(',');

        element.files = fileNames.map((name: string,index: number) => ({
          displayName: name.trim(),
          blobUri: blobUris[index]?.trim(),
          attachmentId: attachmentIds[index]?.trim()
        }));
      }
      
    });
    this.isLoading = false;
  }

  closeActionPopup(event: any) {
    this.popupTitle = "";
    this.popupShow = false;
    this.acdSummary();
  }


  setOwnRequest() {
    let userId = Number(sessionStorage.getItem('userId'));
    this.ownRequest = (userId == this.acdviewrequestTable.onBehalfOfId || userId == this.acdviewrequestTable[0].onBehalfOfId) || this.specialist;
  }

  acdSummary() {
    this.mwoservice.AcdSummary(this.crNo).subscribe((data) => {
      this.acdsummarydata = data;
    })
  }

  navigateToBuilds(id: number) {
    if (id > 0) {
      if (id == this.summaryType['EPL']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Build`);
      }
      else if (id == this.summaryType['EQM']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Build`);
      }
      else if (id == this.summaryType['JobPlanLabor'] || id == this.summaryType['JobPlanParts']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=JobPlan&step=Build`);
      }
      else if (id == this.summaryType['PMRoutes'] || id == this.summaryType['PMAssociations'] || id == this.summaryType['PreventativeMaintenance']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=PM&step=Build`);
      }
      else if (id == this.summaryType['ObsoleteItems']) {
        this.popupShow = true;
      }
      else if (id == this.summaryType['MWOHeader']) {
        this.router.navigateByUrl(`ACD/EditRequest?CR=${this.crNo}&buildType=MWO&step=Build`);
      }
    }
  }

  getHref(id: any): string {
    let link = '';
    if (id > 0) {
      if (id == this.summaryType['EPL']) {
        link = `ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Build`;
      }
      else if (id == this.summaryType['EQM']) {
        link = `ACD/EditRequest?CR=${this.crNo}&buildType=EPL&step=Build`;
      }
      else if (id == this.summaryType['JobPlanLabor'] || id == this.summaryType['JobPlanParts']) {
        link = `ACD/EditRequest?CR=${this.crNo}&buildType=JobPlan&step=Build`;
      }
      else if (id == this.summaryType['PMRoutes'] || id == this.summaryType['PMAssociations'] || id == this.summaryType['PreventativeMaintenance']) {
        link = `ACD/EditRequest?CR=${this.crNo}&buildType=PM&step=Build`;
      }
      else if (id == this.summaryType['MWOHeader']) {
        link = `ACD/EditRequest?CR=${this.crNo}&buildType=MWO&step=Build`;
      }
    }
    return link;
  }


  refreshCommentsHistory() {
    this.acdservice.getCommentsHistory(this.crNo).subscribe((data: any) => {
      data.forEach((element: any) => {
        if (element?.filenametext != null) {         
          const fileNames = element.filenametext.split(',');
          const blobUris = element.blobURIText.split(',');
          const attachmentIds = element.attachmentId.split(',');

          element.files = fileNames.map((name: string,index: number) => ({
            displayName: name.trim(),
            blobUri: blobUris[index]?.trim(),
            attachmentId: attachmentIds[index]?.trim()
          }));
        }
      });
      this.commentsHistory = data;
      this.isLoading = false;
      this.isReloading = false;
      this.closePopup();
    });
  }

  saveAttachment(event: any) {
    this.fileAttachmentDetails.push(event);
  }

  removeFileDetails(file: AttachmentDetails) {
    const deletedFileIndex =
      this.fileAttachmentDetails.findIndex(item =>
        item.fileName === file.fileName
      )
    this.fileAttachmentDetails[deletedFileIndex].operation = 3;
    this.deletedFileList.push(this.fileAttachmentDetails[deletedFileIndex]);
    this.fileAttachmentDetails.splice(deletedFileIndex, 1);
  }


  deleteFileAttachment(file: AttachmentDetails) {
    const deletedFileIndex =
      this.fileAttachmentDetails.findIndex(item =>
        item.fileName === file.fileName
      )
    this.attachmentservice.deleteAttachment(file.fileName ?? '').subscribe({
      next: () => {
        this.removedAttachmentHandling(file);
        this.fileAttachmentDetails.splice(deletedFileIndex, 1);
      },
      error: () => {
        this.commonservice.showNotificationMessage(`Error occuered`, 'error', 'center');
      }
    })
  }
  removedAttachmentHandling(file: AttachmentDetails) {
    let attachmentTypeId = 0;
    let fileName = file.fileName ?? '';

    attachmentTypeId = 26;

    if (file.operation == 1) {
      this.fileAttachmentDetails = this.fileAttachmentDetails.filter((x: AttachmentDetails) => (x.attachmentTypeId !== attachmentTypeId || (x.attachmentTypeId == attachmentTypeId && x.fileName !== fileName)));
    }
    else if (file.operation == 2) {
      this.fileAttachmentDetails.filter((x: AttachmentDetails) => x.id == file.id).forEach((x: any) => {
        x.operation = 3;
      })
    }
  }

  downloadAttachment(filename: string, attachmentId: any, flag: boolean = false) {
    this.attachmentservice.downloadAttachmentById(attachmentId, flag).subscribe({
      next: (res: any) => {
        if (res) {
          filename = new FileNameTransformPipe().transform(filename);
          const filetype = this.getLastExtension(filename);
          let fileOfBlob = new File([res], filename, { type: this.commonservice.getFileType(filetype) });
          saveAs(fileOfBlob);
        }
      },
      error: (err) => {
        console.error('Download failed:', err);
      }
    });  
  }

  
 getLastExtension(name: string): string {
  // Handle cases like ".env" (hidden files) -> no extension
  const lastDot = name.lastIndexOf('.');
  if (lastDot <= 0 || lastDot === name.length - 1) return '';

  return name.slice(lastDot + 1).toLowerCase();
}
  
  isStatusBuild(): boolean {
    if (this.statusFlag === "build" || this.statusFlag?.toLowerCase() === "completed" || this.statusFlag?.toLowerCase() === "cancelled") {
      return false;
    } else {
      return this.specialist;
    }
  }

  isStatusCompleted(): boolean {
    if (this.statusFlag?.toLowerCase() === "completed" || this.statusFlag?.toLowerCase() === "cancelled" || this.ownRequest == false) {
      return false;
    } else {
      return true;
    }
  }

  isStatusClose(): boolean {
    if (this.statusFlag?.toLowerCase() === "completed" || this.statusFlag?.toLowerCase() === "cancelled") {
      return false;
    } else {
      return true;
    }
  }

  showLink(): boolean {
    if (this.statusFlag?.toLowerCase() === "completed" || this.statusFlag?.toLowerCase() === "cancelled") {
      return false;
    } else {
      return true;
    }
  }

  isBtn3Disabled(): boolean {
    return this.specialist === false && this.ownRequest === false;
  }

  closeRequestClick() {
    this.isPopupLoading = true;
    this.showclosepopup = true;
    this.isPopupLoading = false;
  }

  cancelRequestClick() {
    this.showcancelpopup = true;
  }
  closePopup() {
    this.showpopup = false;
    this.showeditpopup = false;
    this.showcancelpopup = false;
    this.showclosepopup = false;
    this.newCommentValue = "";
    this.popuperror = false;
    this.fileAttachmentDetails = [];
    this.deletedFileList = [];
  }
  openPopup(anchor: HTMLElement) {
    this.anchorElement = anchor;
    this.showpopup = true;
  }
  uploadSaveUrl = '';
  uploadRemoveUrl = '';

  successEventHandler(e: any) {
    // Get the file URI from the response
    this.uploadedFile = e.response.json().uri;
  }
  changeStatus(action: any) {
    this.isReloading = true;
    if (this.statusFlag.toLowerCase() !== action.toLowerCase()) {
      var statusIdSelected;
      this.statusList.map((data: any) => {
        if (data.status === action) {
          statusIdSelected = data.statusId;
        }
      });
      this.acdservice.changeStatus(statusIdSelected!, this.crNo).subscribe((data: any) => {
        this.statusFlag = action
        this.refreshCommentsHistory();
        this.acdservice.viewAcd(this.crNo).subscribe((data) => {
          this.statusFlag = data.status.toLowerCase();
          this.isReloading = false;
        })
      });
    }
  }

  changePriority(action: any) {
    this.isReloading = true;
    var priorityIdSelected;
    const updatePriority = action.match(/^(\w+)\s*\((\d+)\)$/);
    this.priorityList.map((data: any) => {
      if (updatePriority) {
        if (data.label === updatePriority[1]) {
          priorityIdSelected = data.id;
        }
      }
    });
    this.acdservice.changePriority(priorityIdSelected!, this.crNo).subscribe((data) => {
      this.getAcdInfo();
    });
  }

  onEditCLick(id: any) {
    this.isPopupLoading = true;
    this.editCommentOpenedId = id;
    this.acdservice.getComment(this.crNo, id).subscribe((data) => {
      this.newCommentValue = data.comment;
      this.fileAttachmentDetails = data.filedetails;
      this.isPopupLoading = false;
    })
    this.showeditpopup = true;
  }
  newCommentRequestData() {
    let submitCommentData = new CommentDataModel();
    submitCommentData.comment = this.newCommentValue;
    submitCommentData.changeRequestId = this.crNo;
    submitCommentData.createdBy = sessionStorage.getItem('userId');
    submitCommentData.changeRequestCommnetsTypeId = 3;
    submitCommentData.fileAttachments = this.fileAttachmentDetails;
    return submitCommentData;
  }

  editCommentData() {
    let commentData = new EditCommentModel();
    commentData.comment = this.newCommentValue;
    commentData.changeRequestId = this.crNo;
    commentData.fileAttachments = [...this.fileAttachmentDetails, ...this.deletedFileList];
    return commentData;
  }
  newCancelData() {
    let submitCommentData = new CloseCancelDataModel();
    submitCommentData.comment = this.newCommentValue;
    submitCommentData.changeRequestId = this.crNo;
    submitCommentData.createdBy = sessionStorage.getItem('userId');
    submitCommentData.changeRequestCommnetsTypeId = 3;
    submitCommentData.fileAttachments = this.fileAttachmentDetails;
    submitCommentData.statusId = this.acdEnv.status.cancelled;
    return submitCommentData;
  }

  newClosedData() {
    let submitCommentData = new CloseCancelDataModel();
    submitCommentData.comment = this.newCommentValue;
    submitCommentData.changeRequestId = this.crNo;
    submitCommentData.createdBy = sessionStorage.getItem('userId');
    submitCommentData.changeRequestCommnetsTypeId = 3;
    submitCommentData.fileAttachments = this.fileAttachmentDetails;
    submitCommentData.statusId = this.acdEnv.status.completed;
    return submitCommentData;
  }

  getAcdInfo() {
    this.acdservice.viewAcd(this.crNo).subscribe((data) => {
      this.acdviewrequestTable[0] = data;
      this.acdviewrequestTable[0].submissionDateTime = data.submitDate || "";
      this.acdviewrequestTable[0].dueDateTime = data.dueDate || "";
      this.acdviewrequestTable[0].createdDateTime = data.createdDate || "";
      if (["New", "Completed"].includes(data.status)) {
        this.hiddenColumns = []
      }

      if (this.statusFlag == "build") { this.buildStatus = true; }
    });
    this.refreshCommentsHistory();
  }

  addComment() {
    if (this.newCommentValue.length > 0) {
      let reqData = this.newCommentRequestData();
      this.acdservice.addComment(reqData).subscribe((data) => {
        this.refreshCommentsHistory();
      })
      this.newCommentValue = "";
    } else {
      this.popuperror = true;
    }

  }

  async deleteAllFiles() {
    const deletePromises = this.deletedFileList.map((file: AttachmentDetails) =>
      this.deleteFileAttachment(file)
    );

    try {
      await Promise.all(deletePromises);
      let reqData = this.editCommentData();
      reqData.changeRequestCommentId = this.editCommentOpenedId;
      this.acdservice.EditComment(reqData).subscribe((data) => {
        this.refreshCommentsHistory();
        this.newCommentValue = "";
      });
    } catch (error) {
      console.error('Error deleting files:', error);
    }
  }

  editComment() {
    if (this.newCommentValue.length > 0) {
      let reqData = this.editCommentData();
      reqData.changeRequestCommentId = this.editCommentOpenedId;
      this.acdservice.EditComment(reqData).subscribe((data) => {
        this.refreshCommentsHistory();
        this.newCommentValue = "";
        this.fileAttachmentDetails = [];
        this.deletedFileList = [];
      });
    } else {
      this.popuperror = true;
    }
  }

  submitClosePopup() {
    if (this.newCommentValue.length > 0) {
      let reqData = this.newClosedData();
      this.acdservice.cancelRequest(reqData).subscribe((data) => {
        window.location.reload();
      })
      this.newCommentValue = "";
    } else {
      this.popuperror = true;
      this.commonservice.showNotificationMessage("Please insert a comment for this action.", "error", "center")
    }

  }

  submitCancelPopup() {
    if (this.newCommentValue.length > 0) {
      let reqData = this.newCancelData();
      this.acdservice.cancelRequest(reqData).subscribe((data) => {
        window.location.reload();
      })
      this.newCommentValue = "";
    } else {
      this.popuperror = true;
      this.commonservice.showNotificationMessage("Please insert a comment for this action.", "error", "center")
    }

  }

  onCommentValueChange(ev: string) {
    this.newCommentValue = ev;
    if (this.newCommentValue.length > 0) {
      this.popuperror = false;
    }
  }

  generateLoadFiles() {
    this.acdservice.generateLoadFiles(this.crNo).subscribe(
      (response: any) => {
        if (response) {
          if (!response.body) {
            this.commonservice.showNotificationMessage('No changes were found in the supplied change request. Please review the request build step.', 'error', 'center');
          } else if (response.status === 200) {
            const fileName = response.body.fileName;
            const fileData = atob(response.body.fileData); // Decode base64 string

            // Create a Blob from the file data
            const byteCharacters = fileData;
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/zip' });

            // Create a link element and trigger a download
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            this.commonservice.showNotificationMessage('Generate Load Files Successfully', 'success', 'center');
          }
          else if (response.status === 204) {
            this.commonservice.showNotificationMessage(
              'No changes were found in the supplied change request. Please review the request build step.',
              'error',
              'center'
            );
          }
          else if (response.status === 500) {
            this.commonservice.showNotificationMessage(
              'Something went wrong while generating load files. Please try again later or contact support.',
              'error',
              'center'
            );
          }
        }
      },
      (error: any) => {
        const msg = (error?.message || '').toLowerCase();

        if (
          error?.status === 504 ||
          msg.includes('timeout') ||
          msg.includes('timed out') ||
          msg.includes('time out')
        ) {
          this.commonservice.showNotificationMessage(
            'Processing is taking longer due to a large response. You will receive an email with the report shortly.',
            'info',
            'center'
          );
        } else if (error?.status === 500) {
          this.commonservice.showNotificationMessage(
            'Something went wrong while generating load files. Please try again later or contact support.',
            'error',
            'center'
          );
        } else {
          // Generic error fallback
          this.commonservice.showNotificationMessage(
            'Processing is taking longer due to a large response. You will receive an email with the report shortly.',
            'info',
            'center'
          );
        }
      }
    );
  }


}

